import { AccessBadge } from "~/pages/manifold-nextgen/components/AccessBadge";
import { AgentAccessLevel } from "~/services/agents";

export const ACCESS_LEVEL_LABEL: Record<AgentAccessLevel, string> = {
  [AgentAccessLevel.OWNER]: "Owner",
  [AgentAccessLevel.EDITOR]: "Editor",
  [AgentAccessLevel.USER]: "User",
};

interface AgentAccessBadgeProps {
  accessLevel: AgentAccessLevel | null;
  /** Suppress the chip for the default USER access level. */
  hideDefault?: boolean;
}

export function AgentAccessBadge({ accessLevel, hideDefault }: AgentAccessBadgeProps) {
  const isHidden = hideDefault && accessLevel === AgentAccessLevel.USER;
  return <AccessBadge label={!isHidden && accessLevel ? ACCESS_LEVEL_LABEL[accessLevel] : null} />;
}
